<template>
  <div style="display: flex; padding: 0px 10px">
    <a-tabs
      v-model:activeKey="activeKey"
      style="display: inline-block; margin-right: 3px"
      type="editable-card"
      hide-add
      :tabBarGutter="2"
      class="tabs__view defalut_tab"
      @tabClick="jump"
      @edit="deltab"
    >
      <a-tab-pane
        :key="`/child-container/yzs-f2e?F2E-harbour-web=#/control-center`"
        :closable="false"
      >
        <template #tab>
          <a-dropdown :trigger="['contextmenu']">
            <div style="display: inline-block">{{ $t("workbenches") }}</div>
          </a-dropdown>
        </template>
      </a-tab-pane>
    </a-tabs>
    <a-tabs
      v-model:activeKey="activeKey"
      type="editable-card"
      style="margin-left: 0px; width: 100%"
      hide-add
      :tabBarGutter="2"
      class="tabs__view"
      @tabClick="jump"
      @edit="deltab"
    >
      <!-- <a-tab-pane
        :key="`/child-container/yzs-f2e?F2E-harbour-web=#/control-center`"
        :closable="false"
      >
        <template #tab>
          <a-dropdown :trigger="['contextmenu']">
            <div style="display: inline-block">{{ $t("workbenches") }}</div>
          </a-dropdown>
        </template>
      </a-tab-pane> -->
      <template v-for="(item, index) in tabList">
        <a-tab-pane
          v-if="item.childAppPath != '/control-center'"
          :key="decodeURIComponent(item.fullPath)"
        >
          <template #tab>
            <a-dropdown :trigger="['contextmenu']">
              <div style="display: inline-block">
                <div class="tabs__view-name">{{ item.title }}</div>
                <div v-if="item.subName" class="tabs__view-sub-name" :title="item.subName">{{ item.subName }}</div>
              </div>
              <template #overlay>
                <a-menu @click="condition(item, index, $event)">
                  <a-menu-item key="current">关闭当前标签</a-menu-item>
                  <a-menu-item key="right">关闭右侧</a-menu-item>
                  <a-menu-item key="left">关闭左侧</a-menu-item>
                  <a-menu-item key="other">关闭其他</a-menu-item>
                  <a-menu-item key="open">新窗口打开</a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </template>
        </a-tab-pane>
      </template>
    </a-tabs>
  </div>
</template>
<script lang="ts">
import { mapState, useStore } from "vuex";
import { TabItem } from "@/store/modules/tabs";
import useActvieTab from "@/hooks/useActiveTab";
import { defineComponent, onBeforeMount, onMounted, watch } from "vue";
import Sortable from "sortablejs";
import { useRoute, useRouter } from "vue-router";
import { AppCollection, F2EHB_NAME } from "@/constant";
import queryString from "query-string";
import { openChildRoute } from "@/router";
import { getLastPathSegment, getPathBeforeLastSlash } from "@/handles/router";
import { APP_LIST } from "@/configs/childAppConfig";
import { useI18n } from "vue-i18n";
import { set } from "store";
declare global {
  interface Window {
    isClickTab: boolean;
  }
}
export default defineComponent({
  name: "layoutTabs",
  computed: {
    ...mapState({
      tabList: (state: any) => state.tabs.tabList as TabItem[],
      includeList: (state: any) => state.keepAlive.includeList,
    }),
  },
  setup() {
    // 激活的tab
    const [activeKey] = useActvieTab();
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const { t } = useI18n();
    // const routeList = router.getRoutes();
    // console.log(activeKey.value, "activeKeyactiveKey");
    // 设置路由缓存(白)名单方法
    // const setKeepAlive = (data: RouteLocationNormalizedLoaded) => {
    //   if (data.meta.keepAlive) {
    //     store.commit("keepAlive/setKeepAlive", data.name as string);
    //   }
    // };
    onBeforeMount(() => {
      const { query: parsedQuery } = queryString.parseUrl(route.fullPath) || {};
      // console.log(route.fullPath, parsedQuery, "route.fullPath");
      const appName =
        APP_LIST.find((v) => route.fullPath.indexOf(v.sysCode + "=") > 0)?.sysCode ||
        null;
      if (!appName || appName === F2EHB_NAME) {
        // eslint-disable-next-line no-console
        console.log("onBeforeMount");
        return;
      }
      // 1. 找到 F2E- 开头的 key
      const appKey: string =
        Object.keys(parsedQuery).find((key) => key === appName) || "";

      // const newPath = parsedQuery[appKey] || "";
      // 2. 提取 path
      let fullPath = (parsedQuery[appKey as string] as string).replace(/^#/, "");
      // 1. 拆分 path 和参数
      let path = "";
      let query: Record<string, any> = {};
      if (fullPath.includes("?")) {
        const [rawPath, search] = fullPath.split("?");
        path = rawPath;
        query = queryString.parse(search || "");
      } else if (fullPath.includes("&")) {
        const [rawPath, ...paramArr] = fullPath.split("&");
        path = rawPath;
        query = queryString.parse(paramArr.join("&"));
      } else {
        path = fullPath;
        query = {};
      }

      // 3. 提取 query
      // const { [appKey]: _, ...query } = parsedQuery;
      const routers = router.getRoutes();
      let itemRoute = routers.find((v) => v.path === path);
      let params = undefined;
      if (!itemRoute) {
        // 截取最后一个斜杠前面的路径
        const newPath = getPathBeforeLastSlash(path);
        // 截取最后一个斜杠后的参数
        const lastSegment = getLastPathSegment(path);
        itemRoute = routers.find((v) => v.path === newPath || v.name === newPath);
        path = newPath;
        // 假设 meta.params 是参数名
        params =
          itemRoute && itemRoute.meta && itemRoute.meta.params
            ? { [itemRoute.meta.params as string]: lastSegment }
            : undefined;
      }
      // console.log(appKey, "appKey");
      if (parsedQuery[appKey]) {
        //1.刷新时 queryString.parseUrl 会将 ？后面的参数解析为Object
        //2.这边先删除  parsedQuery[appKey] 页面路径，生效的key 则是 query 参数，补充到query里面
        delete parsedQuery[appKey];
        if (Object.keys(parsedQuery).length) {
          query = {
            ...query,
            ...parsedQuery,
          };
        }
      }

      openChildRoute(
        {
          path,
          name: (itemRoute?.meta?.title as string) || "",
          appName: appKey as AppCollection,
          component: "null",
          key: "",
          children: [],
          query: Object.keys(query).length ? query : undefined,
          params: params,
        },
        appName as AppCollection
      );
    });

    /**
     * @desc：tab点击
     * @param { string } targetKey 点击的tabKey
     */
    const jump = (targetKey: string) => {
      const tabItem = store.state.tabs.tabList?.find(
        (v: any) => decodeURIComponent(v?.fullPath) === targetKey
      );
      // window.isClickTab = false;
      // if (tabItem?.app && tabItem?.app == F2EHB_NAME) {
      //   window.isClickTab = true;
      // }
      if (!tabItem) {
        // message.warning("该标签页不存在,请刷新页面重试！");
        const defaultTab: TabItem = {
          app: "F2E-harbour-web",
          childAppPath: "/control-center",
          fullPath: "/child-container/yzs-f2e?F2E-harbour-web=#/control-center",
          name: t("workbenches"),
          path: "/child-container/yzs-f2e?F2E-harbour-web=%23%2Fcontrol-center",
          query: undefined,
          title: t("workbenches"),
        };
        store.state.tabs.tabList.push(defaultTab);
        jump(targetKey);
        return;
      }
      if (tabItem.params && Object.keys(tabItem.params)) {
        let path = getPathBeforeLastSlash(tabItem.childAppPath);
        openChildRoute(
          {
            path: path,
            name: tabItem.title || "",
            appName: tabItem.app || F2EHB_NAME,
            component: "null",
            key: "",
            children: [],
            query: tabItem.query
              ? Object.keys(tabItem.query).length
                ? tabItem.query
                : undefined
              : undefined,
            params: tabItem.params
              ? Object.keys(tabItem.params).length
                ? tabItem.params
                : undefined
              : undefined,
          },
          tabItem.app || F2EHB_NAME,
          false,
          true,
          "tab"
        );
        return;
      }

      if (tabItem) {
        openChildRoute(
          {
            path: tabItem.childAppPath,
            name: tabItem.title || "",
            appName: tabItem.app || F2EHB_NAME,
            component: "null",
            key: "",
            children: [],
            query: tabItem.query
              ? Object.keys(tabItem.query).length
                ? tabItem.query
                : undefined
              : undefined,
          },
          tabItem.app || F2EHB_NAME,
          false,
          true,
          "tab"
        );
      }
    };

    /**
     * @desc：删除tab
     * @param { string } targetKey 点击的tabKey
     * @param { string } action 事件类型
     */
    const deltab = (targetKey: string, action: string) => {
      if (action === "remove") {
        store.commit("tabs/delList", targetKey);
        // 修复删除后如果关闭的标签页，左上角有一个白条
        setTimeout(() => {
          (window.document.querySelector('.ant-tabs-dropdown-placement-bottomLeft') as HTMLElement).style.display = 'none';
        }, 100);
      }
    };

    /**
     * @desc: 条件删除
     * @param { TabItem } tab tab对象
     * @param { number } index 序号
     */
    const condition = (tab: TabItem, index: number, item: any) => {
      switch (item.key) {
        case "current":
          store.commit("tabs/delList", decodeURIComponent(tab.fullPath));
          break;
        case "right":
          store.commit("tabs/delRight", index);
          break;
        case "left":
          store.commit("tabs/delLeft", index);
          break;
        case "other":
          store.commit("tabs/delOther", index);
          break;

        case "open":
          store.commit("tabs/openPage", decodeURIComponent(tab.fullPath));
          break;
      }
    };

    onMounted(() => {
      Sortable.create(document.getElementsByClassName("ant-tabs-nav-list")[0], {
        onEnd: (sortableEvent: { newIndex: number; oldIndex: number }) => {
          const newIndex = sortableEvent.newIndex as number;
          const oldIndex = sortableEvent.oldIndex as number;
          arraymove(store.state.tabs.tabList, oldIndex, newIndex);
        },
      });
    });

    const arraymove = (arr: any[], fromIndex: number, toIndex: number) => {
      var element = arr[fromIndex];
      arr.splice(fromIndex, 1);
      arr.splice(toIndex, 0, element);
      // console.log(
      //   "arr",
      //   arr.map((a) => a.name)
      // );
    };

    watch(
      route,
      () => {
        // console.log(activeKey.value, store.state.tabs.tabList, "activeKeyactiveKey");
      },
      { immediate: true }
    );
    return { activeKey, jump, deltab, condition };
  },
});
</script>
<style lang="scss" scoped>
.defalut_tab {
  ::v-deep(.ant-tabs-nav-wrap) {
    // background-color: #dce1e7 !important; // 默认背景颜色
    padding-right: 0px;
  }

  ::v-deep(.ant-tabs-nav-more) {
    display: none !important;
  }
}

.tabs__view {
  height: 42px;
  // margin-left: 10px;

  // 默认状态下的 a-tab-pane 样式
  ::v-deep(.ant-tabs-nav-wrap) {
    background-color: #dce1e7 !important; // 默认背景颜色
  }

  ::v-deep(.ant-tabs-tab) {
    transition: none !important;
    margin: 0 !important;
    user-select: none;
    padding: 0 6px 0 0 !important;
    height: 42px;
    margin-right: 3px !important;
    background: #8e9bac;
    color: #fff;
    border: 0;
    border-radius: 3px 3px 0 0 !important;

    .tabs__view-name {
      line-height: 1;
      font-size: 14px;
      text-align: left;
    }
    .tabs__view-sub-name {
      line-height: 1;
      max-width: 100px;
      margin-top: 3px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #fff;
      text-align: left;
    }

    .ant-tabs-tab-btn {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
    }

    &:hover {
      .ant-tabs-tab-remove {
        opacity: 1;
      }
    }

    .ant-dropdown-trigger {
      line-height: 1.4;
      color: #fff;
      // font-weight: 600;
    }

    .ant-tabs-tab-remove {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 12px;
      width: 12px;
      margin-left: 3px;
      border-radius: 5px;
      color: #fff;
      // background: #dde1e6;
      font-size: 1rem;
      font-weight: bold;
      opacity: 0;
      // transition: opacity 0.3s ease;
    }
  }

  // ::v-deep(.ant-tabs-tab) :hover {
  //   color: red;

  //   .ant-tabs-tab-remove {
  //     opacity: 1;
  //   }
  // }

  ::v-deep(.ant-tabs-nav-more) {
    padding: 0px 16px !important;
  }

  // 选中状态下的 a-tab-pane 样式
  ::v-deep(.ant-tabs-tab-active) {
    border: 0;
    color: #000 !important; // 选中时字体颜色为黑色
    background: #fff;

    .tabs__view-sub-name {
      color: #757575;
    }

    .ant-dropdown-trigger {
      color: #000;
    }

    .ant-tabs-tab-remove {
      color: #000;
      opacity: 1;
    }

    &:after {
      border-bottom: 30px solid #fff;
    }
  }

  // 下拉触发器的样式
  ::v-deep(.ant-dropdown-trigger) {
    // margin-left: 6px;
    padding: 0 0px 0px 6px;
  }

  // Tab 栏的样式
  ::v-deep(.ant-tabs-bar) {
    margin: 0 0 8px 0;
  }

  // Tab 删除按钮的样式
  ::v-deep(.ant-tabs-tab-remove) {
    margin-left: 0px;
    padding-left: 0px;
  }
}
</style>
